import type { Day } from 'date-fns'
import type { PnlAttributionBasis } from '@/types/services/performance'
import type { UserSession } from '@/types/services/user'

export const themeValues = ['system', 'light', 'dark', 'black'] as const
export type Theme = (typeof themeValues)[number]
export type AdminsView = 'table' | 'cards'

export interface TourFlow {
  scenario_key: string
  current_step: number
  finished: boolean
}

export interface PortfolioGlobalDefaults {
  types?: string[]
  roiPeriodSeconds?: number
  showOnlyModified?: boolean
  futuresAsToken?: boolean
  groupFuturesUnderBase?: boolean
}

export interface PortfolioEntityDefaults {
  blockchains?: string[]
  segments?: string[]
  categories?: string[]
  assetSources?: string[]
  tags?: string[]
  categoryTags?: string[]
  segmentTags?: string[]
  protocols?: string[]
}

export interface PortfolioDefaultFilters {
  global?: PortfolioGlobalDefaults
  entities?: Record<string, PortfolioEntityDefaults>
}

export type PnlAttributionGroupBy =
  | 'none'
  | 'allocation'
  | 'segment'
  | 'category'

export interface PnlAttributionEntityDefaults {
  valueMode?: 'value' | 'percentage'
  periodSeconds?: number
  groupBy?: PnlAttributionGroupBy
  basis?: PnlAttributionBasis
  currencyId?: string
}

export interface UserSettings {
  id: string
  user_id: string
  base_currency_id: string
  base_crypto_id: string
  two_factor: 'none' | 'totp'
  session_timeout: number | null
  confirmed: boolean
  last_seen_new_defi_services: string | null
  additional: {
    hide_small?: number
    hide_small_bool?: boolean
    table_pagination?: number
    date_format?: string
    privacy_mode?: boolean
    profile_icon_color?: string
    theme?: Theme
    tour_flow?: TourFlow | null
    week_starts_on?: Day
    admins_view?: AdminsView
    admins_show_deactivated?: boolean
    clients_show_deactivated?: boolean
    referrals_show_deactivated?: boolean
    default_session?: UserSession | null
    last_read_release_notes_version?: string | null
    last_ai_suggestions_notification_date?: string | null
    fund_benchmarks?: Record<string, string | null>
    portfolio_default_filters?: PortfolioDefaultFilters | null
    pnl_attribution_defaults?: Record<
      string,
      PnlAttributionEntityDefaults
    > | null
  }
}

export type UserSettingsWithRequiredAdditional = Omit<
  UserSettings,
  'additional'
> & {
  additional: Required<UserSettings['additional']>
}
